import { uiModel, UIModel } from './ui'

export interface StoreModel {
  ui: UIModel
}

export const storeModel: StoreModel = {
  ui: uiModel,
}
